import React from 'react';
import { colors } from './constants';
import { getBadgeStyle, calculateDuration } from './helpers';

const BedList = ({ filteredBeds, handleBedClick, handleBedRightClick, currentWard }) => {
  const styles = {
    bedList: {
      display: 'flex',
      flexDirection: 'column',
      gap: '12px',
      marginTop: '20px'
    },
    bedListItem: {
      background: colors.cream50,
      border: `1px solid rgba(94, 82, 64, 0.12)`,
      borderRadius: '8px',
      padding: '16px',
      display: 'grid',
      gridTemplateColumns: '80px 1fr auto',
      gap: '16px',
      alignItems: 'center',
      cursor: 'pointer',
      transition: 'all 0.2s ease'
    },
    bedId: {
      fontSize: '16px',
      fontWeight: 600,
      color: colors.slate900
    },
    bedDetails: {
      display: 'flex',
      flexDirection: 'column',
      gap: '4px'
    },
    detailRow: {
      fontSize: '13px',
      color: colors.slate500
    },
    bedActions: {
      display: 'flex',
      flexDirection: 'column',
      gap: '4px',
      alignItems: 'flex-end'
    },
    emptyState: {
      padding: '48px 24px',
      textAlign: 'center',
      color: colors.slate500,
      fontSize: '14px'
    },
    priceTag: {
      fontSize: '12px',
      fontWeight: 500,
      color: colors.teal600,
      background: 'rgba(33, 128, 141, 0.1)',
      padding: '4px 8px',
      borderRadius: '4px',
      whiteSpace: 'nowrap'
    }
  };

  // Show empty state if no beds
  if (!filteredBeds || filteredBeds.length === 0) {
    return (
      <div style={styles.emptyState}>
        <p>No beds found in this ward.</p>
        <p style={{ fontSize: '12px', marginTop: '8px' }}>
          Click "Bed Management" to add beds to this ward.
        </p>
      </div>
    );
  }

  return (
    <div style={styles.bedList}>
      {filteredBeds.map(bed => (
        <div
          key={bed.id}
          style={styles.bedListItem}
          onClick={() => handleBedClick(bed)}
          onContextMenu={(e) => handleBedRightClick(e, bed)}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateX(4px)';
            e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.1)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateX(0)';
            e.currentTarget.style.boxShadow = 'none';
          }}
        >
          <div style={styles.bedId}>{bed.id}</div>
          
          <div style={styles.bedDetails}>
            <div style={getBadgeStyle(bed.status)}>{bed.status}</div>
            
            {bed.patient && (
              <>
                <div style={styles.detailRow}>
                  <strong>Patient:</strong> {bed.patient}
                </div>
                <div style={styles.detailRow}>
                  <strong>Doctor:</strong> {bed.doctor}
                </div>
                <div style={styles.detailRow}>
                  <strong>Days:</strong> {calculateDuration(bed.admissionDate)}
                </div>
              </>
            )}
            
            {bed.equipment && bed.equipment.length > 0 && (
              <div style={styles.detailRow}>
                <strong>Equipment:</strong> {bed.equipment.join(', ')}
              </div>
            )}
            
            {bed.floor && (
              <div style={styles.detailRow}>
                <strong>Floor:</strong> {bed.floor}
              </div>
            )}
          </div>
          
          <div style={styles.bedActions}>
            <span style={{ fontSize: '12px', color: colors.slate500, marginBottom: '4px' }}>
              {bed.wardType || 'General Ward'}
            </span>
            
            {/* Display ward-based pricing */}
            {currentWard?.dailyFare && (
              <span style={styles.priceTag}>
                ₹{currentWard.dailyFare}/day
              </span>
            )}
            
            {/* Show bed type if different from standard */}
            {bed.type && bed.type !== 'standard' && (
              <span style={{ fontSize: '11px', color: colors.slate400 }}>
                {bed.type.replace(/_/g, ' ')}
              </span>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default BedList;
